import { Banknote, ExternalLink } from "lucide-react";
import { useT } from "@/i18n/LanguageProvider";

export const Funding = () => {
    const t = useT();
    return (
        <section className="bg-white py-24 sm:py-32" data-testid="funding-section">
            <div className="container-page">
                <div className="grid lg:grid-cols-12 gap-10 items-start">
                    <div className="lg:col-span-5">
                        <span className="overline">{t({ de: "08 / 12 — Förderung", en: "08 / 12 — Funding" })}</span>
                        <h2 className="h-section mt-4">
                            {t({ de: "KfW-Förderung", en: "KfW funding" })}
                            <span className="italic text-brand-500"> {t({ de: "nutzen.", en: "available." })}</span>
                        </h2>
                        <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 border border-brand-500 text-brand-600 font-body text-xs uppercase tracking-[0.18em]">
                            <Banknote size={14} />
                            {t({ de: "Effizienzhaus 40", en: "Energy class 40" })}
                        </div>
                    </div>

                    <div className="lg:col-span-7 space-y-5 font-body text-stone-700">
                        <p className="text-base leading-relaxed">
                            {t({
                                de: <>Für energieeffiziente Neubauten können Förderprogramme der <strong className="text-ink">KfW (Kreditanstalt für Wiederaufbau)</strong> genutzt werden. Bei Gebäuden im Standard Effizienzhaus 40 sind insbesondere zinsvergünstigte Darlehen im Rahmen der Programme für klimafreundlichen Neubau möglich.</>,
                                en: <>Energy-efficient new builds qualify for funding programmes of the <strong className="text-ink">KfW (German federal investment bank)</strong>. For buildings at energy class 40, in particular subsidised loans under the climate-friendly new-build programmes are available.</>,
                            })}
                        </p>
                        <p className="text-base leading-relaxed">
                            {t({
                                de: "Die Förderung erfolgt in der Regel über durchleitende Banken und bietet langfristige Darlehen mit attraktiven Konditionen für Eigennutzer und Kapitalanleger.",
                                en: "Funding is typically provided through your bank and offers long-term loans with attractive terms for owner-occupiers and investors.",
                            })}
                        </p>

                        <div className="mt-8 flex flex-wrap items-center gap-3 pt-6 border-t border-stone-200">
                            <span className="overline">{t({ de: "Förderinstitution", en: "Funding institution" })}</span>
                            <span className="font-heading text-lg text-ink">KfW</span>
                            <a
                                href="https://www.kfw.de/inlandsfoerderung/Privatpersonen/Neubau/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-1 text-sm text-brand-600 hover:text-brand-700"
                                data-testid="kfw-link"
                            >
                                {t({ de: "Mehr bei kfw.de", en: "More at kfw.de" })} <ExternalLink size={13} />
                            </a>
                        </div>

                        <p className="text-xs text-stone-500 pt-4">
                            {t({
                                de: "Hinweis: Förderbedingungen und Programme können sich ändern. Bitte informieren Sie sich vor Kaufabschluss bei der KfW oder Ihrer",
                                en: "Note: funding terms and programmes can change. Please verify before purchase with KfW or your",
                            })}
                            {t({
                                de: " Hausbank über die aktuellen Konditionen.",
                                en: " bank about current terms.",
                            })}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
